import {useContext} from 'react'
import {DynamicTable} from '../../../../components/DynamicTable'
import {PRODUCT_REPORT_COLUMNS} from '../../utils'
import ProductReportTableRow from './ProductReportTableRow'
import {ProductReportContext} from '../../context'

const ProductReportTable = () => {
  const {productData, isLoading, onSortingChange, filters} = useContext(ProductReportContext)

  return (
    <DynamicTable
      id='product-report-table'
      data={productData}
      sortableColumns={PRODUCT_REPORT_COLUMNS}
      TableRow={ProductReportTableRow}
      loading={isLoading}
      filters={filters}
      onSortingChange={onSortingChange}
      tableClass='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'
      noDataMessage='No product inquiry data found'
      permissionPath='inquires'
    />
  )
}

export default ProductReportTable
